/**
 * Generates a cryptographically secure random string containing URL-safe characters
 * Uses unreserved characters from RFC 3986: [0-9a-zA-Z._~-]
 * @param length - The desired length of the random string
 * @returns A random string of the specified length that can be safely transmitted as URL params
 */
export const cryptoRandomString = (length: number): string => {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ._~-';
  const charsLength = chars.length;
  const randomBytes = new Uint8Array(length);

  // Use Web Crypto API for cryptographically secure random values
  crypto.getRandomValues(randomBytes);

  let result = '';
  for (let i = 0; i < length; i++) {
    // Use modulo to map random byte to character index
    // For better distribution, we reject values that would cause bias
    const byte = randomBytes[i];
    const maxValid = 256 - (256 % charsLength);

    if (byte < maxValid) {
      result += chars[byte % charsLength];
    } else {
      // If byte causes bias, get a new random byte
      const newByte = new Uint8Array(1);
      crypto.getRandomValues(newByte);
      result += chars[newByte[0] % charsLength];
    }
  }

  return result;
};
